export default {
      id: "ic-para-thumbdown-usage",
      viewBox: "0 0 14 15",
      url: "../dist/images/" + "sprite.svg#ic-para-thumbdown-usage",
      toString: function () {
        return this.url;
      }
    }